module.exports = __webpack_public_path__ + "static/media/Home-warranty-sky-blue.7bd4dfc5.gif";